/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
  useState,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import WidgetTrigger from './page/widget/WidgetTrigger';
import WidgetForm from './page/widget/WidgetForm';
import survey from './context/survey';
import { useShouldEmbeddedCheck } from '../../embedded-type/hooks';
import resizing from './context/resizing';
import actions from '../../embedded-type/broadcast/actions/nps';
import { Init } from '../../embedded-type/broadcast';

/**
 * {@link WidgetTrigger} > {@link WidgetForm} mount します
 * - WidgetTrigger - config.triggerIdName element チェックをおこないます
 * - WidgetForm - survey 親 `form` タグ
 * @param {*} [nps={}] Redux.store - nps, embedded type nps から送信されます
 * @param {*} props React.props
 * @return {*} React.node
 * @constructor
 */
const Main = ({ nps = {}, ...props }) => {
  const resizingContext = useContext(resizing.Context);
  /**
   * state {object} - {@link config}.reduce 戻り値
   * dispatch {function} - {@link config}.Context state 変更関数 - type 指定を行います
   */
  const { state, dispatch } = useContext(survey.Context);

  const embedded = useShouldEmbeddedCheck(state.config);
  // console.log('Main - embedded', embedded);
  // if (!embedded) {
  //   return (
  //     <WidgetTrigger state={state} dispatch={dispatch} embedded={embedded}>
  //       <WidgetForm state={state} dispatch={dispatch} embedded={embedded} />
  //     </WidgetTrigger>
  //   );
  // }
  //
  // // 埋込み型
  // return <WidgetForm state={state} dispatch={dispatch} embedded={embedded} />;

  // @since 20191211 - embedded type 連携にしようします
  // Redux.store.nps から React.Context.survey.state へ変換します
  useEffect(() => {
    if (nps.type === actions.type.CHANGE) {
      Init.nps();
      // ---
      state.type = survey.events.UPDATE;
      state.step = 1;
      state.config.nps.checked = nps.payload.checked;
      state.nps.name = nps.payload.name;
      state.nps.value = nps.payload.value;
      dispatch(state);
    }
  }, [nps, state, dispatch]);

  return (
    <WidgetTrigger
      state={state}
      dispatch={dispatch}
      embedded={embedded}
      desktop={resizingContext.state.desktop}
      nps={nps}
      {...props}
    >
      <WidgetForm
        state={state}
        dispatch={dispatch}
        embedded={embedded}
        desktop={resizingContext.state.desktop}
        nps={nps}
        {...props}
      />
    </WidgetTrigger>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/phase2/survey/Main.js